import React, { useCallback, useEffect, useRef, useState } from "react";
import "./FilterBar.css";
import useMediaQuery, { DESKTOP_QUERY } from "../useMediaQuery";
import FilterLayoutContext from "./FilterLayoutContext";
import ActiveFilterChips from "./ActiveFilterChips";
import FilterSheet from "./FilterSheet";

export { default as FilterLayoutContext } from "./FilterLayoutContext";
export { default as FilterGroup } from "./FilterGroup";
export { default as ActiveFilterChips } from "./ActiveFilterChips";

export default function FilterBar({
  primary,
  secondary,
  chips = [],
  onClearAll,
  resultCount,
  resultNoun = "results",
  isUpdating = false,
}) {
  const isDesktop = useMediaQuery(DESKTOP_QUERY);
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);

  const close = useCallback(() => {
    setOpen(false);
    if (triggerRef.current) {
      triggerRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (isDesktop) {
      setOpen(false);
    }
  }, [isDesktop]);

  const meta = (
    <span className="nfl-filter-meta" aria-live="polite">
      {isUpdating ? <span className="nfl-updating">Updating…</span> : null}
      {isDesktop && typeof resultCount === "number" ? (
        <span>
          <b>{resultCount}</b> {resultNoun}
        </span>
      ) : null}
    </span>
  );

  if (isDesktop) {
    return (
      <section className="nfl-filterbar" aria-label="Filters">
        <div className="nfl-inner">
          <FilterLayoutContext.Provider value="bar">
            <div className="nfl-filterbar-row">
              {primary}
              {meta}
            </div>
            {secondary ? <div className="nfl-filterbar-row">{secondary}</div> : null}
          </FilterLayoutContext.Provider>
          {chips.length > 0 ? (
            <div className="nfl-filterbar-row">
              <ActiveFilterChips chips={chips} onClearAll={onClearAll} />
            </div>
          ) : null}
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="nfl-filterbar-compact" aria-label="Filters">
        <button
          ref={triggerRef}
          type="button"
          className="nfl-filter-button"
          onClick={() => setOpen(true)}
          aria-haspopup="dialog"
          aria-expanded={open}
        >
          Filters
          {chips.length > 0 ? <span className="nfl-filter-count">{chips.length}</span> : null}
        </button>
        <ActiveFilterChips chips={chips} />
        {meta}
      </section>
      <FilterSheet
        open={open}
        onClose={close}
        onClearAll={onClearAll}
        resultCount={resultCount}
        resultNoun={resultNoun}
      >
        <FilterLayoutContext.Provider value="sheet">
          {primary}
          {secondary}
        </FilterLayoutContext.Provider>
      </FilterSheet>
    </>
  );
}
